<h1>Base Cad</h1>
<ng-content></ng-content>
